/**
 * Session expiry handling: clear auth storage and redirect to login.
 * Use when API/GraphQL returns 401 or UNAUTHENTICATED/TOKEN_EXPIRED.
 */

import { clearStoredSession } from "@/lib/authStorage";
import { withAppBase } from "@/lib/appPaths";

const LOGIN_PATH = withAppBase("/login");

export function clearSessionAndRedirectToLogin(): void {
  clearStoredSession();
  const search = new URLSearchParams(window.location.search);
  search.set("session_expired", "1");
  const url = `${window.location.origin}${LOGIN_PATH}?${search.toString()}`;
  window.location.replace(url);
}

export function isSessionExpiryError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const e = err as Record<string, unknown>;
  const status =
    typeof (e as any)?.response?.status === "number"
      ? (e as any).response.status
      : typeof (e as any)?.status === "number"
        ? (e as any).status
        : undefined;
  if (status === 401) return true;
  const code =
    (e?.response as { errors?: Array<{ extensions?: { code?: string } }> })
      ?.errors?.[0]?.extensions?.code ?? (e as { code?: string }).code;
  return code === "UNAUTHENTICATED" || code === "TOKEN_EXPIRED";
}
